import { useState } from 'react';
import { useFormValidated } from '../common/FormValidationContext';
import { useAccessibleId } from '../common/hooks/useAccessibleId';
import { Form, InputGroup } from 'react-bootstrap';
import { MAX_NUMBER } from '../../../constants/constants';
import { formatCurrency, formatNumber } from '../../../utils/formatters';

const CurrencyField = ({ value, min, max, scale = 2, fieldName, onChange, readonly, disabled, required, isSubmitting }) => {
  // set defaults
  min = min? min: 0;
  max = max? max: MAX_NUMBER;
  
  const [touched, setTouched] = useState(false);
  const validated = useFormValidated();
  const fieldNameDisplay = fieldName? fieldName: 'Currency';
  const controlId = useAccessibleId(fieldNameDisplay);
  
  const getPledgeError = () => {
    if (!value) return `${fieldNameDisplay} is required.`;
    if (value > max || value < min) return `${fieldNameDisplay} must be between ${formatCurrency(min)} and ${formatCurrency(max)}.`;
    return null;
  };

  const handleBlur = () => {
    setTouched(true);

    if (value !== '' && value !== null && value !== undefined) {
      const rounded = formatNumber(value, scale);
      onChange(rounded);
    }
  };

  const errorMessage = getPledgeError();
  const isInvalid = (required && (touched || validated) && !!errorMessage) || (!!errorMessage && value !== '' && value !== null && value !== undefined);

  return (
  <Form.Group controlId={controlId}>
    <InputGroup>
      <InputGroup.Text className={`rounded-end-0 ${isInvalid? 'bg-danger-subtle border-danger': ''}`}>$</InputGroup.Text>
      <Form.Floating>
        <Form.Control
          type="number"
          min={min}
          max={max}
          step="0.01"
          value={value ?? ''}
          onChange={(e) => {
            setTouched(true);
            onChange(e.target.value);
          }}
          onBlur={handleBlur}
          onWheel={(e) => e.target.blur()}
          readOnly={readonly}
          required={required}
          disabled={disabled || isSubmitting}
          isInvalid={!!errorMessage && touched}
          placeholder=" "
        />
        
        <Form.Label className={required? 'required-field': ''}>
          {fieldNameDisplay}
        </Form.Label>
      </Form.Floating>
    </InputGroup>

    <Form.Control.Feedback
      type="invalid"
      className={isInvalid ? 'd-block' : undefined}>
      {errorMessage}
    </Form.Control.Feedback>
    {readonly && <Form.Text muted>Auto-calculated</Form.Text>}
  </Form.Group>
)};

export default CurrencyField;